import { head, get } from 'lodash';
import moment from 'moment';

import {
	IFT_ADD_PAYMENTS,
	IFT_SELECT_PAYMENT,
	IFT_DELETE_PAYMENT,
	IFT_UPDATE_PAYMENT,
	IFT_UPDATE_SELECTED_PAYMENT_DETAILS,
	IFT_CLEAR_SELECTED_PAYMENT,
	IFT_UPDATE_PRE_BOOKED_CHECKED,
	SUBMIT_IFT_PAYMENT_REVIEW_SUCCESS,
	IFT_UPDATE_SEND_AMOUNT_CURRENCY,
	IFT_SET_PAYMENT_TO_EDIT,
	SUBMIT_IFT_PAYMENT_CONFIRMED_SUCCESS,
	SUBMIT_IFT_EDIT_PAYMENT_SUCCESS,
	SUBMIT_IFT_EDIT_PAYMENT_FAILURE,
	IFT_SET_AUTHORISERS,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
	RESET_IFT_DAILY_LIMIT_AUTHORISATION,
} from './actions';
import { RESET_PAYMENT_AUTHORISATION } from '../payments/actions';
import { SUBMIT_CALENDAR_SUCCESS } from '../calendar/actions';
import { SUBMIT_GET_EXCHANGE_RATES_SUCCESS, SUBMIT_GET_EXCHANGE_RATES_REQUEST } from '../rates/actions';
import { RESET_APP } from '../page/actions';
import { isConflictAndDailyLimitError } from '../../helpers/apiResponse';
import { unauthorisedDailyLimitFilter, unauthorisedTransactionLimitFilter } from '../commonSelectors/selectors';
import { getAuthorisationInfo } from '../../helpers/reducerHelper';

export const initialState = {
	payments: [],
	selectedPayment: {},
	editing: false,
	isPaymentListEdit: false,
};

const ift = (state = initialState, action) => {
	switch (action.type) {
		case IFT_ADD_PAYMENTS:
			return { ...state, payments: [...state.payments, ...action.payments] };
		case IFT_SELECT_PAYMENT:
			return {
				...state,
				selectedPayment: state.payments.find((payment) => payment.id === action.paymentId),
				isPaymentListEdit: action.isPaymentListEdit,
			};
		case IFT_CLEAR_SELECTED_PAYMENT:
			return { ...state, selectedPayment: {} };
		case IFT_DELETE_PAYMENT:
			return {
				...state,
				payments: state.payments.filter((payment) => payment.id !== action.paymentId),
				addingPayments: false,
			};
		case IFT_UPDATE_PAYMENT: {
			const { payment } = action;
			return {
				...state,
				payments: state.payments.map((item) => (item.id !== payment.id ? item : payment)),
				addingPayments: false,
			};
		}

		case IFT_UPDATE_SELECTED_PAYMENT_DETAILS: {
			const { key, value } = action;
			return {
				...state,
				selectedPayment: {
					...state.selectedPayment,
					[key]: value,
				},
			};
		}
		case IFT_UPDATE_PRE_BOOKED_CHECKED: {
			const { isPreBooked } = action;
			return {
				...state,
				selectedPayment: {
					...state.selectedPayment,
					isPreBookedRate: isPreBooked,
				},
			};
		}

		case SUBMIT_CALENDAR_SUCCESS: {
			const {
				payload: { dates },
			} = action;
			const firstDate = head(dates);
			const date = firstDate.submission ? moment(firstDate.submission) : '';
			return { ...state, selectedPayment: { ...state.selectedPayment, date } };
		}
		case SUBMIT_IFT_PAYMENT_REVIEW_SUCCESS: {
			const userId = get(action, 'meta.userId');
			const newPayments = state.payments.map((payment) => {
				const response = action.payload.apiResponses.find((item) => item.id === payment.id);

				const {
					authorisation,
					singleAuthoriserList,
					multiAuthoriserList,
					authorisers,
					authorisersGroup,
					isDefaultAuthorisers,
				} = getAuthorisationInfo(userId, response);

				return {
					...payment,
					authorisation,
					singleAuthoriserList,
					multiAuthoriserList,
					authorisers,
					authorisersGroup,
					isDefaultAuthorisers,
				};
			});

			return {
				...state,
				payments: newPayments,
			};
		}
		case SUBMIT_GET_EXCHANGE_RATES_REQUEST: {
			return { ...state, selectedPayment: { ...state.selectedPayment, rates: {} } };
		}
		case SUBMIT_GET_EXCHANGE_RATES_SUCCESS: {
			return { ...state, selectedPayment: { ...state.selectedPayment, rates: action.payload } };
		}
		case IFT_UPDATE_SEND_AMOUNT_CURRENCY:
			return {
				...state,
				selectedPayment: {
					...state.selectedPayment,
					isSendAmountFromDebitCurrency: action.isSendAmountFromDebitCurrency,
					sendAmount: '',
					rates: {},
				},
			};
		case SUBMIT_IFT_PAYMENT_CONFIRMED_SUCCESS: {
			const payments = state.payments.map((payment) => {
				const response = action.payload.apiResponses.find((item) => item.id === payment.id);
				const confirmation = {
					...response.body,
					responseCode: response.code,
					authType: get(response, 'body.verification_type', ''),
				};
				return { ...payment, confirmation };
			});
			return { ...state, payments };
		}
		case RESET_APP:
			return initialState;
		case IFT_SET_PAYMENT_TO_EDIT: {
			const { payment } = action;
			return { payments: [payment], selectedPayment: payment, editing: true, addingPayments: false };
		}
		case SUBMIT_IFT_EDIT_PAYMENT_SUCCESS: {
			const payments = state.payments.map((payment) => {
				const response = action.payload;
				const confirmation = {
					...response,
					responseCode: 401,
					authType: get(response, 'response.verification_type'),
				};
				return { ...payment, confirmation };
			});
			return { ...state, payments };
		}
		case SUBMIT_IFT_EDIT_PAYMENT_FAILURE: {
			if (action.payload.status === 401) {
				const payments = state.payments.map((payment) => {
					const response = action.payload;
					const confirmation = {
						...response,
						responseCode: 401,
						authType: get(response, 'response.verification_type'),
					};
					return { ...payment, confirmation };
				});
				return { ...state, payments };
			}
			return state;
		}
		case IFT_SET_AUTHORISERS:
			return {
				...state,
				payments: state.payments.map((payment) => {
					if (payment.id !== action.paymentId) return payment;
					return { ...payment, authorisers: action.authorisers };
				}),
			};
		case RESET_PAYMENT_AUTHORISATION: {
			return {
				...state,
				payments: state.payments.map((payment) => {
					if (payment.id !== action.id) return payment;
					const { authorisation, ...newPayment } = payment;
					return newPayment;
				}),
			};
		}
		case SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS: {
			return {
				...state,
				payments: state.payments.map((payment) => {
					const response = action.payload.apiResponses.find((item) => item.id === payment.id);
					if (isConflictAndDailyLimitError(response)) {
						const authorisation = { ...get(response, 'body', {}), responseCode: get(response, 'code', 0) };
						return { ...payment, authorisation };
					}
					return payment;
				}),
			};
		}
		case RESET_IFT_DAILY_LIMIT_AUTHORISATION: {
			return {
				...state,
				payments: state.payments.map((payment) => {
					if (unauthorisedDailyLimitFilter(payment) || unauthorisedTransactionLimitFilter(payment)) {
						const { authorisation, ...newPayment } = payment;
						return newPayment;
					}
					return payment;
				}),
			};
		}
		default:
			return state;
	}
};

export default ift;
